<template>
    <div class="public_container personnel_leave_office_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <div class="user_info_box">
                <div class="img_box">
                    <img :src="userDetails.header_img ? userDetails.header_img : defaultImg" loading="lazy" alt="" />
                </div>
                <div class="user_info_middle">
                    <p>
                        <span class="ellipsis">{{ userDetails.name }}</span>
                        <span
                            class="tag_status"
                            :class="
                                formData.quit_status == 0
                                    ? 'tag_status0'
                                    : formData.quit_status == 1
                                    ? 'tag_status1'
                                    : 'tag_status2'
                            "
                            >{{
                                formData.quit_status == 0
                                    ? "待离职"
                                    : formData.quit_status == 1
                                    ? "已离职"
                                    : formData.quit_status == 2
                                    ? "已取消"
                                    : ""
                            }}</span
                        >
                    </p>
                    <p>{{ userDetails.did_name || '--'}}</p>
                </div>
                <!-- <div class="user_info_right" @click="handleClickSelectUser">
                    <van-icon name="arrow" />
                </div> -->
            </div>
            <p v-if="formData.quit_status === 0" class="tip_text">
                该员工已办理离职，请确认工作交接后，操作确认离职
            </p>
            <div class="form_module_title">离职信息</div>
            <van-form
                ref="customForm"
                :rules="customFormRules"
                error-message-align="right"
                input-align="right"
                label-width="10em"
                :show-error-message="false"
                scroll-to-error
            >
                <van-field
                    required
                    v-model="formData.quit_date"
                    name="quit_date"
                    label="离职日期"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect('quit_date')"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
                <van-field
                    required
                    v-model="formData.quit_type_text"
                    name="quit_type"
                    label="离职类型"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect('quit_type')"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
                <van-field
                    required
                    v-model="formData.quit_reason"
                    name="quit_reason"
                    label="离职原因"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect('quit_reason')"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
                <div class="vertical_input_wrap">
                    <van-field
                        v-model="formData.quit_note"
                        name="quit_note"
                        label="离职备注"
                        placeholder="请输入"
                        type="textarea"
                        maxlength="200"
                        :show-word-limit="true"
                    >
                    </van-field>
                </div>
            </van-form>
            <CustomFormMobile
                v-if="dataLoaded"
                ref="customFormMobile"
                :field_list="formInfoList"
                :form_detail="formInfoData"
                :is_edit_mode="false"
                :is_preview_mode="true"
                :is_form_module="true"
                :pk_id="userId"
            />
        </div>
        <!-- 人员选择 -->
        <UserSearchSelect
            :userSelectVisible.sync="userSelectVisible"
            :userSelectTitle="'选择人员'"
            @selectUserData="handleSelectUserData"
            v-if="userSelectVisible"
        />
        <!-- 日期选择 -->
        <van-calendar
            v-model="showDateCalendar"
            color="#2990FF"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @confirm="handleDateCalenderConfirm"
        />
        <!-- 单选弹框 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="showRadioPicker"
            :show="showRadioPicker"
        >
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in quitTypeList"
                        :key="item.type_id"
                        class="radio_option_item"
                        @click="handleClickRadioOption(item)"
                        v-text="item.type_value"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <!-- 离职原因弹框 -->
        <van-overlay
            :show="showReasonPicker"
            v-if="showReasonPicker"
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
        >
            <div class="contact_select_wrap">
                <div class="contact_select_header">
                    <van-icon name="arrow-left" @click="handleClickContactPickerClose"></van-icon>
                    <span class="title" v-text="'离职原因'"></span>
                    <el-link :underline="false" type="primary" @click="handleClickReasonPickerConfirm">确定</el-link>
                </div>
                <ul class="contact_select_list">
                    <li v-for="item in reasonOptions" :key="item" @click="handleClickReasonConfirm(item)">
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>
        </van-overlay>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>
<script>
import { getFormFields, getUserDetail, getQuitReason, applyQuit, quitInfo, editQuitInfo } from "@/api";
import { formatDate } from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MLeaveOffice",
    components: { ReturnNavBar, UserSearchSelect, CustomFormMobile },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            userId: "",
            userInfo: {},
            loading: false,
            btnDisabled: false,
            userDetails: {
                header_img: "",
                name: "",
                did_name: "",
                entry_status: "",
                is_active: "",
                quit_info: {}
            },
            formData: {
                id: "",
                quit_date: "",
                quit_type: "",
                quit_type_text: "",
                quit_reason: "",
                quit_note: "",
            },
            customFormRules: {},
            nowFieldKey: "", // 当前操作的字段
            userSelectVisible: false,
            showDateCalendar: false,
            dateCalendarMin: new Date("1970-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            showRadioPicker: false,
            quitTypeList: [
            ], // 离职类型
            showReasonPicker: false,
            reasonOptions: [
            ], // 离职原因
            selectReasonData: {},
            dataLoaded: false,
            formInfoList: [],
            formInfoData: {},
        };
    },
    created() {
        if (this.$route.query) {
            this.userId = this.$route.query.uid;
            // 编辑状态有ID
            this.formData.id = this.$route.query.id || "";
        }
        this._getFromFields();
        this.getQuitReason();
    },
    methods: {
        // 获取字段
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "users",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    if (this.userId) {
                        this.getUserDetailInfo();
                    }
                }
            });
        },
        // 获取人员详情
        getUserDetailInfo() {
            getUserDetail({
                user_id: this.userId,
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.userDetails.header_img = res.data.avatar;
                        this.userDetails.name = res.data.name.value;
                        this.userDetails.did_name =
                            res.data.department_id.text && res.data.department_id.text.length
                                ? res.data.department_id.text[0].full_path
                                : "";
                        this.userDetails.entry_status = res.data.entry_status;
                        this.userDetails.is_active = res.data.is_active;
                        this.userDetails.quit_info = res.data.quit_info || {}
                        this.formInfoData = res.data;
                        this.dataLoaded = true;
                        this.loading = false;
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                })
                .catch(() => {});
        },
        // 离职类型
        getQuitReason() {
            getQuitReason({}).then((res) => {
                if (res.code === 200) {
                    this.quitTypeList = res.data;
                    if (this.formData.id) {
                        this.getQuitInfo();
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 离职信息回显
        getQuitInfo() {
            this.loading = true;
            quitInfo({ id: this.formData.id }).then((res) => {
                if (res.code === 200) {
                    let { quit_date, quit_type, quit_reason, quit_note , quit_status} = res.data;
                    this.formData.quit_date = quit_date;
                    this.formData.quit_type = String(quit_type);
                    this.formData.quit_type_text =
                        this.quitTypeList.find((item) => item.type_id == quit_type)?.type_value || "--";
                    this.formData.quit_reason = quit_reason;
                    this.formData.quit_note = quit_note || "--";
                    this.formData.quit_status = quit_status
                    this.reasonOptions = this.quitTypeList.find((item) => item.type_id == quit_type)?.reason || []
                } else {
                    this.$toast(res.message);
                }
                this.loading = false;
            });
        },
        handleClickSelect(field_key) {
            this.nowFieldKey = field_key;
            switch (field_key) {
                case "quit_date":
                    this.showDateCalendar = true;
                    break;
                case "quit_type":
                    this.showRadioPicker = true;
                    break;
                case "quit_reason":
                    this.showReasonPicker = true;
                    break;
            }
        },
        handleClickSelectUser() {
            this.userSelectVisible = true;
        },
        handleSelectUserData(data) {
            this.userInfo = data;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.formData.quit_date = formatDate(date, "date");
            this.showDateCalendar = false;
        },
        // 单选框确认
        handleClickRadioOption(item) {
            this.formData.quit_type_text = item.type_value;
            this.formData.quit_type = item.type_id;
            this.reasonOptions = item.reason || [];
            this.showRadioPicker = false;
            this.formData.quit_reason = "";
        },
        handleClickContactPickerClose() {
            this.showReasonPicker = false;
        },
        // 离职原因确认
        handleClickReasonPickerConfirm() {
            if (!this.selectReasonData) return this.$toast("请选择离职原因");
            this.showReasonPicker = false;
            this.formData.quit_reason = this.selectReasonData;
            this.selectReasonData = null;
        },
        // 离职原因选择
        handleClickReasonConfirm(item) {
            this.selectReasonData = item;
            this.handleClickReasonPickerConfirm();
        },
        handleClickConfirm() {
            this.$refs.customForm.validate().then(() => {
                let postData = {
                    uid: this.userId,
                    quit_date: this.formData.quit_date,
                    quit_type: this.formData.quit_type,
                    quit_reason: this.formData.quit_reason,
                    quit_note: this.formData.quit_note,
                };
                this.btnDisabled = true;
                if (this.formData.id) {
                    postData.id = this.formData.id;
                    editQuitInfo(postData).then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                        this.btnDisabled = false;
                    });
                } else {
                    applyQuit(postData).then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                        this.btnDisabled = false;
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.personnel_leave_office_wrap {
    .user_info_box {
        height: 68px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        background-color: #ffffff;
        .img_box {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            flex-shrink: 0;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .user_info_middle {
            flex: 1;
            overflow: hidden;
            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
            }
            p:nth-child(1) {
                font-weight: 700;
                color: rgba(51, 51, 51, 1);
            }
            p:nth-child(2) {
                color: rgba(102, 102, 102, 1);
            }
            .tag_status {
                margin-left: 8px;
                flex-shrink: 0;
                height: 18px;
                padding: 0 4px;
                border-radius: 5px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                &.tag_status2 {
                    background-color: ba(240, 170, 50, 0.15);
                    color: rgba(240, 170, 50, 1);
                }
                &.tag_status1 {
                    background-color: rgba(90, 179, 51, 0.15);
                    color: rgba(90, 179, 51, 1);
                }
                &.tag_status0 {
                    background-color: rgba(228, 65, 68, 0.15);
                    color: rgba(228, 65, 68, 1);
                }
            }
        }
        .user_info_right {
            flex-shrink: 0;
            .van-icon {
                color: rgba(153, 153, 153, 1);
                font-size: 18px;
            }
        }
    }
    .tip_text {
        padding: 2px 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        background-color: #ffffff;
        .link_text {
            vertical-align: top;
            height: 22px;
            color: rgba(41, 144, 255, 1);
            border: 0;
            padding: 0;
        }
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
    .van-form {
        .vertical_input_wrap {
            ::v-deep .van-cell {
                display: block;

                .van-cell__value {
                    text-align: left;
                    margin-top: 4px;

                    .van-field__control--right {
                        text-align: left;
                    }
                }

                .van-field__control--custom {
                    display: block;
                }
            }
        }
    }
    .radio_option_wrap {
        width: 100%;
        height: 100%;
        padding: 0 16px 35px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .radio_option_list {
            border-radius: 8px;
            max-height: calc(100% - 90px);
            overflow-y: auto;

            .radio_option_item {
                background-color: #ffffff;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                padding: 10px 0;
                color: #666666;
                border-bottom: 1px solid #dedede;

                &:first-child {
                    border-radius: 8px 8px 0 0;
                }

                &:last-child {
                    border-bottom: none;
                    border-radius: 0 0 8px 8px;
                }
            }
        }

        .cancel_btn {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-radius: 8px;
            box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
            margin-top: 10px;
        }
    }
    .contact_select_wrap {
        width: 100%;
        height: 285;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        position: absolute;
        bottom: 0;
        border-radius: 8px 8px 0 0;
        padding: 12px 16px;

        .contact_select_header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .van-icon-arrow-left {
                font-size: 24px;
            }

            .title {
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
            }
        }

        .contact_select_list {
            overflow-y: auto;
            flex: 1;
            margin-top: 10px;
            max-height: calc(100% - 48px);
            li {
                padding: 7px 0;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 0.8);
                text-align: center;
            }
        }
    }
    .form_module_title {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        padding: 10px 16px 10px 28px;
        position: relative;

        &::before {
            content: "";
            width: 4px;
            height: 22px;
            opacity: 1;
            border-radius: 20px;
            background: #2990ff;
            position: absolute;
            left: 16px;
        }
    }
    .custom_form_wrap {
        height: auto !important;
    }
}
</style>
